import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["theme", "to", "href", "children", "dismissible", "active", "disabled", "readOnly", "onClick", "onDismiss", "className", "closeButtonProps"];
import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Base, Interactive } from '../Base';
import { SrOnly } from '../Helper';
import Svg from '../Svg';
var styles = {
  "root": "Tag-root_3UI7k",
  "themeGrey": "Tag-themeGrey_2YKcx",
  "themeWhite": "Tag-themeWhite_1QVnG",
  "themePurple": "Tag-themePurple_GQI4h",
  "label": "Tag-label_23dia",
  "static": "Tag-static_3cmB7",
  "dismissible": "Tag-dismissible_2K1xX",
  "focusable": "Tag-focusable_2Faqj",
  "hoverable": "Tag-hoverable_3iJk8",
  "active": "Tag-active_3A65O",
  "closeButton": "Tag-closeButton_BQ2M-",
  "closeIcon": "Tag-closeIcon_1T8kU"
};
function Tag(_ref) {
  var _clsx, _clsx2;
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'grey' : _ref$theme,
    to = _ref.to,
    href = _ref.href,
    children = _ref.children,
    dismissible = _ref.dismissible,
    active = _ref.active,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    onClick = _ref.onClick,
    onDismiss = _ref.onDismiss,
    className = _ref.className,
    closeButtonProps = _ref.closeButtonProps,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var interactive = Boolean(to || href || onClick);
  var isDismissible = dismissible && !disabled && !readOnly;
  var interactiveProps = function () {
    if (interactive && disabled) return {
      tagName: 'button',
      disabled: disabled
    };
    if (interactive && readOnly) return {
      tagName: 'button'
    };
    // Let the Interactive component deal with those props and tagName.
    if (interactive) return {
      to: to,
      href: href,
      onClick: onClick,
      interactive: interactive
    };
    // Default to a `span` when no interactivity props are passed,
    return {
      tagName: 'span'
    };
  }();
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.themeGrey, theme === 'grey'), _defineProperty(_clsx, styles.themeWhite, theme === 'white'), _defineProperty(_clsx, styles.themePurple, theme === 'purple'), _clsx), className);
  var labelClasses = clsx(styles.label, (_clsx2 = {}, _defineProperty(_clsx2, styles.static, !isDismissible), _defineProperty(_clsx2, styles.dismissible, isDismissible), _defineProperty(_clsx2, styles.focusable, interactive && !disabled), _defineProperty(_clsx2, styles.hoverable, interactive && !disabled && !readOnly), _defineProperty(_clsx2, styles.active, active), _clsx2));
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      size: "small",
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement(Interactive, _extends({
      title: typeof children === 'string' ? children : undefined,
      boxSizing: "border",
      paddingY: "none",
      flex: true,
      flexAlignItemsCenter: true,
      weight: "regular",
      color: "base",
      className: labelClasses
    }, interactiveProps), /*#__PURE__*/React.createElement(Base, {
      tagName: "span",
      overflow: "truncate"
    }, children)), isDismissible ?
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-indexer]
    React.createElement(CloseButton, _extends({
      onClick: onDismiss
    }, closeButtonProps)) : null)
  );
}
// $FlowFixMe[cannot-spread-indexer]
function CloseButton(props) {
  var _useTranslator = useTranslator(),
    __ = _useTranslator.__;
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "button",
    type: "button",
    flex: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    border: "none",
    padding: "none",
    interactive: true,
    className: styles.closeButton
  }, props), /*#__PURE__*/React.createElement(Svg, {
    name: "miniCrossBold",
    focusable: "false",
    className: styles.closeIcon
  }), /*#__PURE__*/React.createElement(SrOnly, null, __('Dismiss')));
}
export default Tag;